<template>
  <a-config-provider :locale="zhCN"
    :theme="{ token: { colorPrimary: '#D40800' } }"
  >
    <router-view></router-view>
  </a-config-provider>
  
</template>

<script>
import zhCN from 'ant-design-vue/es/locale/zh_CN';

export default {
  name: 'App',
  data() {
    return {
      zhCN,
    };
  },
}
</script>

<style>
#app {
  text-align: left;
  color: #2c3e50;
  margin: 0;  
  padding: 0;  
  height: 100vh;  
  min-width: 1024px;
  background:#EEFFDD;
}
.ant-layout .ant-layout-header {
  padding-inline: 0px;
  line-height: 40px;
}
.ant-menu-inline .ant-menu-item {
  border-radius: 0px;
  margin-inline: 0px;
  margin-block: 0px;
  width: calc(100% - 0px);
  height: 50px;
  line-height: 50px;
}
.ant-menu-light.ant-menu-horizontal {
  color: #F5BBBB;
  background: #D40800;
  font-size: 15px;
}
.ant-menu-light.ant-menu-horizontal >.ant-menu-item-selected {
  color: #ffffff;
  background: #bb0701;
  font-size: 15px;
  font-weight: bold;
}
.ant-menu-light.ant-menu-horizontal > .ant-menu-item-selected::after {  
  border-bottom-width: 3px;
  border-bottom-color: #ffffff;
}
.ant-menu-light.ant-menu-horizontal >.ant-menu-item:hover::after {
  border-bottom-width: 3px;
  border-bottom-color: #ffffff;
}
.ant-menu-light.ant-menu-horizontal >.ant-menu-item:hover:not(.ant-menu-item-selected):not(.ant-menu-submenu-selected) {
  color: #ffffff;
}

.ant-menu-light  {
  color: #717171;
  background: #EEF1F1;
  font-size: 15px;
}
.ant-menu-light .ant-menu-item-selected {
  color: #151515;
  background: #FFFFFF;
  font-size: 15px;
  font-weight: bold;
}
.ant-btn-dangerous {
  background: #FFA500 !important;
}
#webpack-dev-server-client-overlay {
  display: none !important;
}
</style>
